import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { useState } from "react";
import { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

/**
 * Docs : https://jpuri.github.io/react-draft-wysiwyg/#/docs
 * @param {*} props 
 * @returns 
 */
export default function Wysiwyg({value, onChange, onImageUpload, label}){

    const [editorState, setEditorState] = useState(null)

    useEffect(() => {

        if(!editorState){

            const contentBlock = htmlToDraft(value);

            if(contentBlock){
                const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                const editorState = EditorState.createWithContent(contentState);
                setEditorState(editorState);
            }
        }

    }, [value, editorState])


    const handleChange = state => {
        setEditorState(state)
        let html = draftToHtml(convertToRaw(state.getCurrentContent()));
        return onChange(html)
    }

    const options = () => {
        let options = [
            'inline', 
            'blockType', 
            'fontSize', 
            //'fontFamily', 
            'list', 
            'textAlign', 
            'colorPicker', 
            'link', 
            'emoji', 
            //'image', 
            'remove', 
            'history',
            //'embedded',
        ];

        if(onImageUpload) options.push('image');

        return options;
    }


    return <Stack spacing={1}>

        {label && 
            <Typography color='text.secondary'>{label}</Typography>
        }

        <Editor
            editorState={editorState}
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            onEditorStateChange={handleChange}
            editorStyle={{
                border: 'solid 1px lightgrey', 
                borderRadius: '5px', 
                padding: '0px 5px', 
                minHeight: '400px'
            }}
            toolbar={{
                options: options(),
                image: {
                    className: undefined,
                    component: undefined,
                    popupClassName: undefined,
                    urlEnabled: false,
                    uploadEnabled: true,
                    alignmentEnabled: true,
                    uploadCallback: onImageUpload,
                    previewImage: true,
                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                    alt: { present: false, mandatory: false },
                    defaultSize: {height: 'auto', width: 'auto'},
                },
            }}
  
        />
    
    </Stack>
}